var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.storage = void 0;

var store_1 = __importDefault(require("store"));

exports.storage = {
  get: function get(key) {
    var stored = store_1.default.get(key);
    if (!stored) return null;

    try {
      var item = JSON.parse(stored);
      var now = new Date();

      if ((item === null || item === void 0 ? void 0 : item.expiry) && now.getTime() > (item === null || item === void 0 ? void 0 : item.expiry)) {
        store_1.default.remove(key);
        return null;
      }

      return item === null || item === void 0 ? void 0 : item.value;
    } catch (e) {
      return stored;
    }
  },
  set: function set(key, value) {
    var days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var now = new Date();
    var expiry = days && now.getTime() + days * 86400000;
    var item = {
      value: value,
      expiry: expiry
    };
    store_1.default.set(key, JSON.stringify(item));
  },
  setAll: function setAll(items) {
    return items.map(function (item) {
      return store_1.default.set(item === null || item === void 0 ? void 0 : item.key, item === null || item === void 0 ? void 0 : item.value);
    });
  },
  remove: function remove(key) {
    return store_1.default.remove(key);
  },
  wipe: function wipe() {
    return store_1.default.clearAll();
  },
  all: function all() {
    var output = [];
    store_1.default.each(function (value, key) {
      output.push({
        key: key,
        value: value
      });
    });
    return output;
  }
};